import { c as _c } from "react/compiler-runtime";
import { CurrencyEnum } from '@systemeio/ui';
import { AFFILIATE_SETTINGS_API } from 'modules/profile/affiliate-settings/api/affiliate-settings-api';
import AddBankDetailsModal from 'modules/profile/affiliate-settings/components/add-bank-details-modal';
import EditBankDetailsModal from 'modules/profile/affiliate-settings/components/edit-bank-details-modal';
import { useWiseRecipientApi } from 'modules/profile/affiliate-settings/hooks/use-wise-recipient-api';
import { AffiliateSettingsInterface, WiseRecipientId, WiseRecipientInterface } from 'modules/profile/affiliate-settings/types/affiliate-settings-interface';
import React from 'react';
import ConfirmationModal from 'shared/components/confirmation-modal';
import { Table } from 'shared/components/table/table';
import { ColumnDefinitionInterface } from 'shared/components/table/types/column-interface';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { useUpdateData } from 'shared/hooks/use-update-data';
import { KeyedMutator } from 'swr';
interface BankTransferTableProps {
  affiliateSettingsData: AffiliateSettingsInterface;
  mutateAffiliateSettings: KeyedMutator<AffiliateSettingsInterface>;
}
interface BankTransferTableDataInterface {
  items: BankTransferTableDataInterfaceItem[];
  hasMore: boolean;
}
interface BankTransferTableDataInterfaceItem {
  id: WiseRecipientId;
  currency: CurrencyEnum;
  wiseRecipient: WiseRecipientInterface | null;
}
function BankTransferTable(t0) {
  const $ = _c(32);
  const {
    affiliateSettingsData,
    mutateAffiliateSettings
  } = t0;
  const {
    t
  } = useLocoTranslation();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      api: AFFILIATE_SETTINGS_API
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const updateData = useUpdateData(t1);
  const {
    deleteWiseRecipientDetails
  } = useWiseRecipientApi();
  let t2;
  if ($[1] !== affiliateSettingsData.allowedCurrencies || $[2] !== affiliateSettingsData.wiseRecipients) {
    let t3;
    if ($[4] !== affiliateSettingsData.wiseRecipients) {
      t3 = (currency, index) => ({
        id: affiliateSettingsData.wiseRecipients.find(wiseRecipient => wiseRecipient.currency === currency)?.id || index,
        key: currency,
        currency,
        wiseRecipient: affiliateSettingsData.wiseRecipients.find(wiseRecipient_0 => wiseRecipient_0.currency === currency) || null
      });
      $[4] = affiliateSettingsData.wiseRecipients;
      $[5] = t3;
    } else {
      t3 = $[5];
    }
    t2 = affiliateSettingsData.allowedCurrencies.map(t3);
    $[1] = affiliateSettingsData.allowedCurrencies;
    $[2] = affiliateSettingsData.wiseRecipients;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[6] !== t2) {
    t3 = {
      items: t2,
      hasMore: false
    };
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const bankTransferTableData = t3;
  let t4;
  if ($[8] !== t) {
    t4 = t("global.currency");
    $[8] = t;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t4) {
    t5 = {
      key: "currency",
      header: t4,
      widthPercent: 50,
      onRender: _temp
    };
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t) {
    t6 = t("dashboard.user_settings.affiliate_commissions.wire_table.bank_details_title");
    $[12] = t;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== mutateAffiliateSettings) {
    t7 = data_0 => {
      if (data_0.wiseRecipient) {
        return <div className="flex flex-col gap-1.5"><EditBankDetailsModal wiseRecipient={data_0.wiseRecipient} mutateAffiliateSettings={mutateAffiliateSettings} />{data_0.wiseRecipient.errorMessage && <p className="text-danger whitespace-normal">{data_0.wiseRecipient.errorMessage}</p>}</div>;
      }
      return <AddBankDetailsModal currency={data_0.currency} mutateAffiliateSettings={mutateAffiliateSettings} />;
    };
    $[14] = mutateAffiliateSettings;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t6 || $[17] !== t7) {
    t8 = {
      key: "wiseRecipient",
      header: t6,
      widthPercent: 50,
      onRender: t7
    };
    $[16] = t6;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== t5 || $[20] !== t8) {
    t9 = [t5, t8];
    $[19] = t5;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  const bankTransferTableColumns = t9;
  let t10;
  if ($[22] !== affiliateSettingsData || $[23] !== deleteWiseRecipientDetails || $[24] !== updateData) {
    t10 = id => async () => {
      await deleteWiseRecipientDetails(id);
      await updateData(false, affiliateSettingsData);
    };
    $[22] = affiliateSettingsData;
    $[23] = deleteWiseRecipientDetails;
    $[24] = updateData;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  const removeWiseRecipientDetails = t10;
  let t11;
  if ($[26] !== affiliateSettingsData.allowedCurrencies.length || $[27] !== bankTransferTableColumns || $[28] !== bankTransferTableData || $[29] !== removeWiseRecipientDetails || $[30] !== t) {
    t11 = <>{affiliateSettingsData.allowedCurrencies.length > 0 ? <Table actions={{
        custom: [{
          name: "delete",
          shouldRender: _temp2,
          caption: t("dashboard.actions.title.remove"),
          onActionRender: (opened, onClose, instance, key) => <ConfirmationModal opened={opened} onClose={onClose} onConfirm={removeWiseRecipientDetails(instance.id)} confirmationText={t("dashboard.user_settings.affiliate_commissions.wire_table.remove_confirmation")} title={t("confirmation_modal.default_title")} key={key} />
        }]
      }} data={bankTransferTableData} columns={bankTransferTableColumns} /> : <div className="text-yellow">{t("dashboard.user_settings.affiliate_commissions.wire_table.sale_warning_title")}</div>}</>;
    $[26] = affiliateSettingsData.allowedCurrencies.length;
    $[27] = bankTransferTableColumns;
    $[28] = bankTransferTableData;
    $[29] = removeWiseRecipientDetails;
    $[30] = t;
    $[31] = t11;
  } else {
    t11 = $[31];
  }
  return t11;
}
function _temp2(data_1) {
  return !!data_1.wiseRecipient;
}
function _temp(data) {
  return <div>{data.currency.toUpperCase()}</div>;
}
export default BankTransferTable;